"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchByPfnReducer = void 0;

var Immutable = require("seamless-immutable");

var redux_ts_simple_1 = require("redux-ts-simple");

var TitleHubActions_1 = require("../../actions/TitleHubActions");

var INITIAL_STATE = Immutable({
  inProgress: false
});
exports.fetchByPfnReducer = new redux_ts_simple_1.ReducerBuilder(INITIAL_STATE).on(TitleHubActions_1.TitleHubActions.fetchTitleByPfnInProgress, function (state, action) {
  return state.merge({
    inProgress: action.payload
  });
}).on(TitleHubActions_1.TitleHubActions.fetchTitleByPfnCompleted, function (state, action) {
  return state.merge({
    titlesInfo: action.payload
  }, {
    deep: true
  });
}).build();